<template>
    <el-container class="mill-index">
        <el-main>
            <el-header class="column-header">
                矿机收益
            </el-header>

            <router-view></router-view>
            <div class="mill-chart-filter">
                <el-form :inline="true" size="mini" :model="millParam">
                    <el-form-item label="单日币价">
                        <el-input placeholder="单日币价" v-model="millParam.p"></el-input>
                    </el-form-item>
                    <el-form-item label="残值率">
                        <el-input placeholder="残值率" v-model="millParam.r"></el-input>
                    </el-form-item>
                    <el-form-item label="挖矿天数">
                        <el-input placeholder="挖矿天数" v-model="millParam.day"></el-input>
                    </el-form-item>
                    <el-form-item label="G/成本">
                        <el-input placeholder="G/成本" v-model="millParam.x"></el-input>
                    </el-form-item>
                    <el-form-item label="机会成本率">
                        <el-input placeholder="机会成本率" v-model="millParam.fee"></el-input>
                    </el-form-item>
                    <el-form-item label="难度递增率">
                        <el-input placeholder="难度递增率" v-model="millParam.d"></el-input>
                    </el-form-item>
                    <el-form-item label="日期">
                        <el-date-picker
                        v-model="millParam.date"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btn__style" @click="submitForm">确认</el-button>
                    </el-form-item>
                </el-form>
                <div>
                    <el-radio-group v-model="chartType" size="mini" @change="chartTypeEvent">
                        <el-radio-button label="币"></el-radio-button>
                        <el-radio-button label="人民币"></el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="mill-chart-box" ref="millChart"></div>

            <el-table stripe style="width: 100%;" :data="millData">
                <el-table-column v-for="(item, index) in tableTitle" :key="'date_'+index"
                :prop="item.key" :label="item.title">
                    <template slot-scope="scope">
                        <span v-if="item.key !== 'time'">{{(scope.row[item.key]).toFixed(6)}}</span>
                        <span v-else>{{scope.row[item.key]}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
// import { postMillData } from '@/api/api.js';
import $ from 'jquery';
// import { types } from 'util';

export default {
    data: function () {
        return {
            millParam: {
                token: '142536',
                p: 1236.12,
                r: 0.25,
                day: 365,
                x: 100000,
                fee: 0.0003,
                d: 0.00001,
                date: "2020-03-01"
            },
            millData: [],
            formData: [],
            tableTitle: [
                {title: '日期', key: 'time'},
                {title: '日成本(未包含残值)', key: 'cost_day'},
                {title: '残值现金流', key: 'sur_value'},
                {title: '每日成本', key: 'cost_day_sur'},
            ],
            chartType: '币',
            tag: '统计1'
        }
    },
    mounted() {
        this.getMillData();
    },
    computed: {
        
    },
    methods: {
        getMillData() {// 数据获取
            var that = this;
            $.ajax({
                url: 'http://192.168.1.228:8090/predict',
                type: 'post',
                data: this.millParam,
                success: function (res) {
                    let rut = JSON.parse(res);
                    if (rut.code == 200) {
                        that.millData = rut.data;
                        that.chartTypeEvent();
                    } else {
                        that.$notify.info({
                            title: '提示',
                            message: rut.msg,
                            offset: 100
                        });
                    }
                }
            })
        },

        initChart() {// 初始化阶梯图
            let myChart = this.$echarts.init(this.$refs.millChart);
            let chartData = this.handleData();
            let that = this;

            let option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "line"
                    },
                    textStyle: {
                        align: 'left'
                    },
                    backgroundColor: '#19224D',
                    padding: 15,
                    formatter: function (data) {
                        let index_data = data[0];
                        // var unity;

                        // if (that.chartType == '币') {
                        //     unity = '';
                        // } else {
                        //     unity = '￥';
                        // }
                        let mark_html = index_data.axisValue+'<br>'+
                        '日收益：' + index_data.data+'<br>'+
                        '日收益：'+chartData.cal[index_data.dataIndex]+'<br>'+
                        '每日成本：'+data[1].value+ '<br>'+
                        '每日成本(未包含残值)：'+chartData.y2[index_data.dataIndex];
                        return mark_html;
                    }
                },
                legend: {
                    data: [
                        { name: '日收益', icon: 'rect' },
                        { name: '每日成本', icon: 'rect' },
                    ],
                    textStyle: {
                        color: "#999"
                    }
                },
                color: ['#db5634', '#008ef5'],
                backgroundColor: '#2A2D2E',
                xAxis: {
                    type: "category",
                    data: chartData.x,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#7B818E',
                    },
                },
                yAxis: [{
                    name: '日收益',
                    color: '#7B818E',
                    nameTextStyle: {
                        color: '#7B818E'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#383E56",
                            width: 1
                        },
                    },
                    axisLine: {
                        show: true
                    },
                    axisLabel: {
                        color: '#7B818E',
                    }
                }, {
                    name: '每日成本',
                    color: '#7B818E',
                    position: 'right',
                    nameTextStyle: {
                        color: '#7B818E'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "#383E56",
                            width: 1
                        },
                    },
                    axisLine: {
                        show: true
                    },
                    axisLabel: {
                        color: '#7B818E',
                    }
                }],
                series: [
                    {
                        name: '日收益',
                        data: chartData.y,
                        type: "line",
                        step: "start",
                        yAxisIndex: 0,
                        showAllSymbol: false,
                        symbol: 'circle',
                        symbolSize: 1,
                    },
                    {
                        name: '每日成本',
                        data: chartData.y1,
                        type: "line",
                        step: "start",
                        yAxisIndex: 1,
                        showAllSymbol: false,
                        symbol: 'circle',
                        symbolSize: 1,
                    }
                ]
            };

            myChart.setOption(option);

            myChart.on('click', function (params) {
                let data = that.millData[params.dataIndex];
                that.millParam.p = data.cny.toFixed(2),
                that.millParam.date = data.time
            })
        },

        handleData() {// 数据处理
            let x_arr = [];
            let y_arr = [];
            let y_cal = [];
            let y_arr1 = [];
            let y_arr2 = [];

            for (var i=0; i<this.millData.length; i++) {
                let i_data = this.millData[i];
                let x_data = i_data.time.split('T')[0];
                let y_data = (i_data.income*10).toFixed(6);
                let cal_data = i_data.income*Number(i_data.cny);

                x_arr.push(x_data);
                y_arr.push(y_data);
                y_cal.push(cal_data.toFixed(2));
                y_arr1.push(i_data.cost_day_sur.toFixed(2));
                y_arr2.push(i_data.cost_day.toFixed(2));
            }
            return {
                x: x_arr,
                y: y_arr,
                cal: y_cal,
                y1: y_arr1,
                y2: y_arr2,
            };
        },

        submitForm() {// 提交表单
            this.getMillData();
        },

        chartTypeEvent() {// 表格模式选择
            for (var i=0; i<this.millData.length; i++) {
                let i_data = this.millData[i];
                let price = this.millParam.p;

                if (this.chartType == '币') {
                    i_data.cost_day_sur = (i_data.cost_day_sur / price );
                    i_data.cost_day = (i_data.cost_day / price );
                    i_data.sur_value = (i_data.sur_value / price);
                } else if (this.chartType == '人民币') {
                    i_data.cost_day_sur = (i_data.cost_day_sur * price );
                    i_data.cost_day = (i_data.cost_day * price );
                    i_data.sur_value = (i_data.sur_value * price);
                }
            }
            this.initChart();
        }
    }
}
</script>

<style lang="scss">
.mill-index {
    .mill-chart-box {
        width: 100%;
        height: 400px;
    }
    .el-input__inner {
        background-color: #333333;
        border: 1px solid #333333;
    }
    .mill-chart-filter {
        background-color: #2a2d2e;
        padding: 10px 0;
    }
    .el-popper[x-placement^=bottom] .popper__arrow::after {
            border-bottom-color: transparent;
    }

    .el-table {
        background-color: #2a2d2e;
        font-size: 12px;
        margin-top: 10px;
        .el-table__header-wrapper {
            background-color: transparent;
        }
        tr th.is-leaf, td {
            background-color: transparent;
            border-bottom: 1px solid #5a595a;
            padding: 8px 0;
        }

        tr th.is-leaf {
            background-color: #2a2d2e;
        }
        th, tr {
            background-color: transparent;
        }
    }
    .el-table--border::after, .el-table--group::after, .el-table::before {
        content: '';
        position: absolute;
        background-color: transparent;
        z-index: 1;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td{
        background: #2a2d2e;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td{
        background-color: #2a2d2e;
    }
    tbody {
        tr:hover {
            background-color: #2a2d2e;
            td {
                color: #999999;
                background-color: transparent;
            }
        }
    }

    tr:nth-child(even) {
        background-color: #262829;
    }
    tr:nth-child(odd) {
        background-color: #2e3538;
    }

    .el-radio-button__inner {
        background-color: #c5c1c1;
    }
}
</style>
